﻿import { useEffect, useState } from "react";
import { apiRenacer } from "../../api/axiosClient";
import { useSelector } from "react-redux";
import { getApiError } from "../../utils/getApiError";
import { toast } from "../../utils/toast";

const useFetchObtenerCarnet = () => {

  /* --------------------------  --------------------------  */

  const [imageData, setImageData] = useState();
  const [imageDataError, setImageDataError] = useState();

  /* --------------------------  --------------------------  */

  const { codigoAfiliado, token } = useSelector((state) => state.user);
  const codigoAfilFormat = codigoAfiliado.replace(/-/g, "");

  /* --------------------------  --------------------------  */

  useEffect(() => {
    if (!codigoAfilFormat) return;
    apiRenacer.get("/CarnetPrint/getCarnet", {
      params: {
        codpol: codigoAfilFormat,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setImageData(response.data);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 400) {
            const mensaje = getApiError(error);
            setImageDataError(mensaje);
            toast.warning(mensaje);
          } else if (error.response.status === 401) {
            const mensaje = getApiError(error);
            setImageDataError(mensaje);
            toast.warning(mensaje);

          } else if (error.response.status === 500) {
            const mensaje = getApiError(error);
            setImageDataError(mensaje);
            toast.warning(mensaje);
          }

          const mensaje = getApiError(error);
          setImageDataError(mensaje);
          toast.warning(mensaje);
        } else if (error.request) {
          toast.warning("Ocurrio algo inseperado.");
        }
      });
  }, [codigoAfilFormat, token]);

  /* --------------------------  --------------------------  */

  return { imageData, imageDataError };
};

export default useFetchObtenerCarnet;
